module.exports = "/_next/static/images/nw-logo-fec9f71e09f031026bfbea834ffd6347.svg";